import React, { useEffect } from 'react';
import { withStyles, Theme, createStyles, makeStyles } from '@material-ui/core/styles';

import SplashTables from '../../assets/splashTables.png'
import { Container, Button, Paper, Input, Typography, Grid, InputAdornment, FormControlLabel, Checkbox, FormControl, FormGroup, IconButton, Snackbar, Select, MenuItem } from '@material-ui/core';
import moment from 'moment'
import AttachFile from '@material-ui/icons/AttachFile';
import Delete from '@material-ui/icons/Delete';
import MomentUtils from '@date-io/moment';
import { createTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import BackIcon from '@material-ui/icons/ArrowBackIos';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Alert } from '@material-ui/lab';
import {
    MuiPickersUtilsProvider, DatePicker,
} from '@material-ui/pickers';

import CardActions from '@material-ui/core/CardActions';
import Parse from 'parse';

import firebase from 'firebase/compat/app'
import 'firebase/compat/storage';

import orange from '@material-ui/core/colors/orange';
import blue from '@material-ui/core/colors/blue';
import { postToAPI } from '../helpers/sqlApiCalls';
const defaultMaterialTheme = createTheme({
    palette: {
        primary: blue,
    },
});

const ASSETS_MICROSERVICE_URL = 'http://157.230.55.48:60300'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            '& > *': {
                margin: theme.spacing(1),
            },
        },
        input: {
            display: 'none',
        },
        header: {
            backgroundColor: theme.palette.nav.app,
            [theme.breakpoints.up('sm')]: {
                paddingRight: 104,
                paddingLeft: 104
            },
            [theme.breakpoints.down('sm')]: {
                paddingRight: 48,
                paddingLeft: 48
            },
        },
        headerText: {
            color: '#000',
            fontSize: 28,
            marginTop: 10,
            marginBottom: 10
        },
        buttonColor: {
            backgroundColor: theme.palette.nav.actions,
            color: theme.palette.nav.text
        }
    }),


);



const StyledTableRow = withStyles((theme: Theme) =>
    createStyles({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    }),
)(TableRow);


function Extensiones(props) {

    const classes = useStyles();

    const [selectedDate, setSelectedDate] = React.useState(new Date().getTime());
    const [selectedDateHasta, setSelectedDateHasta] = React.useState(new Date().getTime());
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [selectedURL, setSelectedURL] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [errorOpen, setErrorOpen] = React.useState(false);
    const [buttonSave, setButtonSave] = React.useState(true);


    const user = JSON.parse(localStorage.user)

    const [data, setData] = React.useState({
        cuit: "",
        tipo: "",
    });

    const handleChangeCuit = (e) => {
        
            setData({
                ...data,
                ["cuit"]: e.target.value
            });
                setButtonSave(false)
            
        

    };

    const handleChangeTipo = (e) => {
        if (e) {
            setData({
                ...data,
                ["tipo"]: e.target.value
            });
            setButtonSave(false)
        }

    };


    const handleDateChangeDesde = (date: Date | null) => {
        setSelectedDate(new Date(date).getTime());
        setButtonSave(false)

    };


    const handleDateChangeHasta = (date: Date | null) => {

        setSelectedDateHasta(new Date(date).getTime());
        setButtonSave(false)

    };

    useEffect(() => {
        if (user) {
            setData({
                cuit: user.exemptions && user.exemptions.cuit ? user.exemptions.cuit : data.cuit,
                tipo: user.exemptions && user.exemptions.tipo ? user.exemptions.tipo : data.tipo,
            })
            if (user.exemptions && typeof user.exemptions.urlDoc != 'object') setSelectedURL(user.exemptions.urlDoc)
            if (user.exemptions && user.exemptions.desde) setSelectedDate(user.exemptions.desde)
            if (user.exemptions && user.exemptions.hasta) setSelectedDateHasta(user.exemptions.hasta)
        }
    }, [])

    const handleFileChange = (x) => {
        if (x) {
            var reader = new FileReader();
            reader.readAsDataURL(x.target.files[0]);
            reader.onload = function () {
                // cb(reader.result)
                setSelectedURL(reader.result)
            };
            setSelectedFile(x.target.files[0]);
            setButtonSave(false)
        }
    };

    const handleSubmit = async () => {
        let urlDoc;
        if (selectedURL) {
            if (selectedFile) {
                let resURL = await saveImgDitalOcean(selectedFile, 'exencion')
                if (resURL && Object.values(resURL)[0] && Object.values(resURL)[0].rURL) {
                    urlDoc = Object.values(resURL)[0].rURL
                }
            } else {
                urlDoc = selectedURL
            }
        }
        try {
            const updatedUser = await saveChanges(urlDoc);
            if (updatedUser.status == 200) {
                setOpen(true);
                setButtonSave(true)
            } else {
                setErrorOpen(true);
            }
        } catch (error) {
            setErrorOpen(true);
        }
    }

    const saveChanges = async (urlDoc) => {

        const userData = JSON.parse(localStorage.user)

        let body = {
            "data": [{
                cuit: data.cuit ? data.cuit : "",
                tipo: data.tipo ? data.tipo : "",
                url: urlDoc ? urlDoc : "",
                fecha_desde: selectedDate ? selectedDate : "",
                fecha_hasta: selectedDateHasta ? selectedDateHasta : "",
                t: Date.now(),
                n: userData.n ? userData.n : null,
                bn: userData.bn ? userData.bn : null,
                e: userData.e ? userData.e : null,
                ph: userData.ph ? userData.ph : null,
                ck: userData.k ? userData.k : null
            }]
        }

        const response = await postToAPI(localStorage.env, "Exemptions", body, true, 40000, true)
        return response
    };

    const saveImgDitalOcean = async (archivo, cod) => {

        const fileName = `${user.k}_${Date.now()}_${cod}.jpg`
        const _data = new FormData();
        _data.append('my-file', archivo, fileName);

        const config = {
            method: 'POST',
            body: _data
        };

        const resultURL = await fetch(`${ASSETS_MICROSERVICE_URL}/file/RegisteredCustomers/${window.localStorage.getItem('envId')}`, config); // MICROSERVICIO 
        return resultURL.json();

    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };


    return (
        <div>

            <div className={classes.header}>

                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 115 }}>
                    <div style={{ zIndex: 1 }}>
                        <p className={classes.headerText}>
                            <IconButton onClick={''} aria-label="delete" size="small">
                                <BackIcon style={{ fontSize: 24 }} />
                            </IconButton>Exenciones</p>
                    </div>
                </div>

            </div>
            <Container maxWidth="lg" style={{ marginTop: 50 }}>
                <Paper spacing={2}>
                    <Grid container style={{ padding: 15 }}>
                        {/* <Grid style={{ marginBottom: 10 }} item xs={12}>
                            <Typography variant="subtitle1" gutterBottom>Fecha</Typography>
                            <Typography variant={"body2"}>{moment().format('DD/MM/YYYY')}</Typography>
                        </Grid> */}
                        <Grid style={{ marginBottom: 10 }} item xs={12}>
                            <Typography variant="subtitle1" gutterBottom name='cuit'>CUIT</Typography>
                            <Input fullWidth placeholder="Escribir cuit" onChange={(e) => handleChangeCuit(e)} value={data.cuit} inputProps={{ 'aria-label': 'description' }} />
                        </Grid>
                        <Grid style={{ marginBottom: 10 }} item xs={12}>
                            <Typography variant="subtitle1" gutterBottom>Fecha desde</Typography>
                            <ThemeProvider theme={defaultMaterialTheme}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <DatePicker
                                        autoOk
                                        fullWidth
                                        label="Seleccionar"
                                        format="DD/MM/YYYY"
                                        value={selectedDate}
                                        onChange={handleDateChangeDesde}
                                    />
                                </MuiPickersUtilsProvider>
                            </ThemeProvider>
                        </Grid>
                        <Grid style={{ marginBottom: 10 }} item xs={12}>
                            <Typography variant="subtitle1" gutterBottom>Fecha hasta</Typography>
                            <ThemeProvider theme={defaultMaterialTheme}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <DatePicker
                                        autoOk
                                        fullWidth
                                        label="Seleccionar"
                                        format="DD/MM/YYYY"
                                        value={selectedDateHasta}
                                        onChange={handleDateChangeHasta}
                                    />
                                </MuiPickersUtilsProvider>
                            </ThemeProvider>
                        </Grid>
                        <Grid style={{ marginBottom: 10 }} item xs={12}>
                            <Typography variant="subtitle1" gutterBottom name='tipo'>TIPO</Typography>
                            <Select
                                fullWidth
                                value={data.tipo}
                                label="Seleccionar tipo"
                                onChange={(e) => handleChangeTipo(e)}
                            >
                                <MenuItem value={"EXENCIONES DE PERCEPCION DE IIBB"}>EXENCIONES DE PERCEPCION DE IIBB</MenuItem>
                                <MenuItem value={"EXENCIONES DE PERCEPCION DE IVA"}>EXENCIONES DE PERCEPCION DE IVA</MenuItem>
                            </Select>
                            {/* <Input fullWidth placeholder="Escribir tipo" value={data.tipo} onChange={(e) => handleChangeTipo(e)} inputProps={{ 'aria-label': 'description' }} /> */}
                        </Grid>


                        <Grid style={{ marginBottom: 10 }} item xs={12}>
                            <Typography variant="h6" gutterBottom>Adjunte exencion</Typography>
                            <input
                                accept="image/*,.jpg, .png, .doc"
                                className={classes.input}
                                id="contained-button-file"
                                //multiple
                                type="file"
                                onChange={handleFileChange}
                            />
                            <label htmlFor="contained-button-file">
                                <Button color="primary" component="span" size={"small"} multiple startIcon={<AttachFile />}>
                                    Adjuntar archivo ( opcional)
                                </Button>
                            </label>
                            <div style={{ display: "flex", flexDirection: "row", }}>
                                {selectedURL ?
                                    <Paper elevation={2} style={{ width: 110, height: 170, margin: 5, textAlign: "center", alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                        <img alt="" style={{ width: 100, height: 100, borderRadius: 5 }} src={selectedURL}></img>
                                        <CardActions disableSpacing>
                                            <IconButton
                                                onClick={() => {
                                                    setSelectedURL(null)
                                                    setSelectedFile(null)
                                                }}
                                                aria-label="Borrar"
                                            >
                                                <Delete />
                                            </IconButton>
                                        </CardActions>
                                    </Paper>
                                    : null}


                            </div>
                        </Grid>
                        <Grid item style={{ textAlign: "end" }} xs={12}>
                            <Button variant="contained" style={{ borderRadius: 30 }} onClick={handleSubmit} color="secondary" component="span" disabled={buttonSave}>
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
                <Snackbar open={open} autoHideDuration={1700} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="success">
                        Los cambios se guardaron correctamente!
                    </Alert>
                </Snackbar>
                <Snackbar open={errorOpen} autoHideDuration={1700} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="danger">
                        No se pudieron guardar los cambios!
                    </Alert>
                </Snackbar>
            </Container>
        </div >
    )
}
export default Extensiones